import { ErrorMessage, Form, Formik, FormikErrors } from "formik";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Button, Divider } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import PageHeader from "../../app/layout/PageHeader";
import ValidationErrors from "../errors/ValidationErrors";
import { UpdatePartNotificationSettingsFormValues } from "../../app/models/inventory";
import MyIconDecimalInput from "../../app/common/form/MyIconDecimalInput";

interface Props { }

export default observer(function EditNotificationSettingsModal(props: Props) {
  const { t } = useTranslation(["common", "tickets", "inventory"]);

  const { inventoryPartDetailsStore, inventorySettingsStore, modalStore } = useStore();

  const {
    selectedPartDetails,
    loadInventoryPartDetails,
    loadInventoryPartVendors,
    loadInventoryPartLocations,
    loadInventoryPartTickets,
    updateNotificationSettings,
  } = inventoryPartDetailsStore;

  const {
    inventorySettings,
  } = inventorySettingsStore;

  function handleFormSubmit(
    values: UpdatePartNotificationSettingsFormValues,
    setErrors: (errors: FormikErrors<UpdatePartNotificationSettingsFormValues>) => void,
    setSubmitting: (isSubmitting: boolean) => void
  ) {
    const partId = selectedPartDetails!.id;
    updateNotificationSettings(partId, values)
      .then(() => {
        setSubmitting(false);
        return loadInventoryPartDetails(partId)
          .then(() => {
            loadInventoryPartVendors(partId);
            loadInventoryPartLocations(partId);
            loadInventoryPartTickets(partId);
          })
      })
      .then(() => {
        modalStore.closeModal();
      })
      .catch((error) => {
        setSubmitting(false);
        setErrors(error);
      });
  }
  return (
    <Formik
      initialValues={{
        reOrderLevel: selectedPartDetails?.reOrderLevel ?? inventorySettings?.lowInventoryDefault
      } as UpdatePartNotificationSettingsFormValues}
      onSubmit={(values, { setErrors, setSubmitting }) =>
        handleFormSubmit(values, setErrors, setSubmitting)
      }
    >
      {({
        handleSubmit,
        isValid,
        isSubmitting,
        dirty,
        errors,
      }) => (
        <Form className="ui form error" autoComplete="off" onSubmit={handleSubmit}>
          <PageHeader header={"Update Notification Settings"} type={"h3"} divider={true} getAlerts={true} addTitle={false} />
          <ErrorMessage
            name="error"
            render={() => <ValidationErrors errors={errors.reOrderLevel} />}
          />
          <MyIconDecimalInput
            icon="box"
            iconPosition="left"
            placeholder="0.00"
            label={`${t("pops.reorder_qty", { ns: "tickets" })}:`}
            name="reOrderLevel"
            maxLength={500}
          />
          <Divider></Divider>
          <Button
            color="green"
            className="save_button"
            icon="check"
            content={t("save", { ns: "common" })}
            disabled={isSubmitting || !dirty || !isValid}
            loading={isSubmitting}
            type="submit"
          />
          <Button
            className="save_button"
            onClick={() => modalStore.closeModal()}
            icon="cancel"
            type="reset"
            content={t("cancel", { ns: "common" })}
          />
        </Form>
      )}
    </Formik>
  );
});
